<div class="flex flex-col text-sm border-2 border-lighterText mt-2 mb-2 rounded-2xl py-2 px-6 w-full">
  <span class="font-semibold text-base mb-2">3/3: DATENWEITERGABE AN TOYOTA-UNTERNEHMEN</span>
  <span class="whitespace-pre-line">{{ description }}</span>
</div>
